import { Outlet } from "react-router-dom";
import { ContentContainer, LayoutContainer } from "./DefaultLayoutStyles";
import { Header } from "../components/header/Header";
import WavesBackground from "../components/wavesBackground/WavesBackground";
import Footer from "../components/footer/Footer";

const DefaultLayout = () => {
  return (
    <LayoutContainer>
      <Header />
      <WavesBackground />
      <ContentContainer>
        <Outlet />
      </ContentContainer>
      <Footer />
    </LayoutContainer>
  );
};

export default DefaultLayout;
